import { Globals } from 'src/app/shared/services/globals';
import { Component, OnInit } from '@angular/core';
import { AssetService } from '../shared/services/asset.service';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import * as signalR from '@aspnet/signalr';
import { OwlModule } from 'ngx-owl-carousel';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { UserNotification } from '../shared/models/DTO/uer-notification';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { HomeService } from './services/home.service';
declare function chartKnob(): any;
declare function drawPie(): any;
declare function LoadCrs(): any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

news;
page=1;
pageSize=3;
newsLength;
  loadAPI: Promise<any>;
  SlideOptions = { items: 1, dots: true, nav: true };  
  CarouselOptions = { items: 3, dots: true, nav: true };  
  constructor(public homeService:HomeService,private assetService: AssetService , public globals: Globals, public global: Globals , private toastr: ToastrService) {

   

  
   }


  
  ngOnInit() {

  
  }

 
  







}
